// Centralized theme helpers for dark mode aware colors
export const theme = {
  bg: (isDark: boolean, opts?: { transparency?: number; light?: string; dark?: string }) => {
    if (opts?.light || opts?.dark) return isDark ? (opts?.dark || "#000000") : (opts?.light || "#ffffff");
    const t = opts?.transparency ?? 0.9;
    return isDark ? `rgba(28,28,28,${t})` : `rgba(255,255,255,${t})`;
  },
  text: (isDark: boolean, variant: 'default' | 'muted' = 'default') => {
    if (variant === 'muted') return isDark ? '#9CA3AF' : '#6B7280';
    return isDark ? '#FFFFFF' : '#000000';
  },
  border: (isDark: boolean, alpha = 0.2) => {
    return isDark ? `rgba(255,255,255,${Math.min(alpha, 0.6)})` : `rgba(0,0,0,${Math.min(alpha, 0.5)})`;
  },
  accent: (isDark: boolean, alpha = 0.7) => {
    return isDark ? `rgba(44,44,44,${alpha})` : `rgba(243,244,246,${alpha})`;
  },
  chip: (isDark: boolean) => (isDark ? '#2c2c2c' : '#ffffff'),
  hoverChip: (isDark: boolean) => (isDark ? '#2c2c2c99' : '#ffffff99'),
  shimmerGradient: (isDark: boolean) => (
    isDark
      ? 'linear-gradient(90deg,#303030 0%, #2c2c2c 50%, #1f2937 100%)'
      : 'linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%)'
  ),
  neutralBlock: (isDark: boolean) => (isDark ? '#1c1c1c' : '#ffffff'),
};
